import { useId, useState } from "react"
import { isWebUrl, type SourceKind, type SourceRef } from "./sources"
import "./sources.css"

const KIND_LABEL: Record<SourceKind, string> = { judgment: "Judgment", provision: "Provision", circular: "Circular", other: "Source" }

/**
 * The legal sources a stage relied on: collapsed to "Sources (n)" so the page stays calm, one row per
 * authority when opened. Links open in a new tab. Renders nothing without sources.
 */
export function SourcesList({ sources }: { sources?: SourceRef[] }) {
  const [open, setOpen] = useState(false)
  const listId = useId()
  if (!sources?.length) return null
  return (
    <div className="nsd-src">
      <button type="button" className="ncf-rename" aria-expanded={open} aria-controls={listId} onClick={() => setOpen((v) => !v)}>
        {open ? "Hide sources" : `Sources · ${sources.length}`}
      </button>
      {open ? (
        <ul id={listId} className="nsd-src-l" aria-label="Sources">
          {sources.map((s, i) => {
            const meta = [s.court, s.date, s.citation].filter((x): x is string => !!x && x.trim() !== "")
            const paras = s.paras?.length ? `${s.paras.length > 1 ? "Paras" : "Para"} ${s.paras.join(", ")}` : ""
            return (
              <li key={`${s.title}-${i}`} className="nsd-src-i">
                <span className="ncf-eyebrow nsd-src-k">{KIND_LABEL[s.kind] ?? "Source"}</span>
                <span className="nsd-src-b">
                  {isWebUrl(s.url) ? (
                    <a className="nsd-src-name" href={s.url} target="_blank" rel="noopener noreferrer">{s.title}<span aria-hidden="true"> ↗</span></a>
                  ) : (
                    <span className="nsd-src-name">{s.title}</span>
                  )}
                  {meta.length || paras ? <span className="ncf-doc-p nsd-src-m">{[...meta, paras].filter(Boolean).join(" · ")}</span> : null}
                </span>
                {s.verified ? <span className="ncf-doc-u nsd-src-v" title="Read in full through the research tools">Verified</span> : null}
              </li>
            )
          })}
        </ul>
      ) : null}
    </div>
  )
}
